import { render, staticRenderFns } from "./AddCompanyDocumentModal.vue?vue&type=template&id=793cd2d2&scoped=true&"
import script from "./AddCompanyDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./AddCompanyDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793cd2d2",
  null
  
)

export default component.exports